import React from 'react';
import { ArrowRight } from 'lucide-react';
export function HeroSection() {
  const scrollToOffer = () => {
    const element = document.getElementById('oferta');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  const scrollToInfo = () => {
    const element = document.getElementById('que-incluye');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section id="hero" className="relative flex items-center justify-center overflow-hidden pt-16 sm:pt-20 pb-2 sm:min-h-screen" data-id="element-80">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-81">
        <img src="https://cdn.magicpatterns.com/uploads/hxmUQEkNi74reMmJBXb1id/ChatGPT_Image_25_feb_2026,_22_36_40.png" alt="Aula de filosofía" className="w-full h-full object-cover object-center scale-110 origin-center" style={{
        objectPosition: '50% 35%'
      }} data-id="element-82" />
        {/* Gradient Overlay: 70% opacity bottom -> 35% top */}
        <div className="absolute inset-0 bg-gradient-to-t from-[#0a1628]/95 via-[#0a1628]/70 to-[#0a1628]/45" data-id="element-83"></div>
      </div>

      <div className="relative z-10 max-w-5xl mx-auto px-3 sm:px-6 text-center flex flex-col items-center" data-id="element-84">
        {/* Badge */}
        <div className="inline-block bg-[#fbbf24]/40 backdrop-blur-sm text-white font-semibold px-3 py-0.5 rounded-full text-[10px] sm:text-sm mb-0.5 border border-[#fbbf24]/50 text-center leading-tight" data-id="element-85">
          ⭐ El recurso #1 para docentes de Filosofía ⭐
        </div>

        {/* H1 Title */}
        <h1 className="text-[1.4rem] sm:text-4xl md:text-5xl lg:text-7xl font-extrabold text-white leading-none mb-0 drop-shadow-xl" data-id="element-86">
          Kit Completo Filosofía Lista
        </h1>

        {/* Recursos Completos */}
        <p className="text-[#fbbf24] font-extrabold text-xl sm:text-3xl md:text-5xl lg:text-6xl leading-none mb-0 drop-shadow-xl" data-id="element-87">
          Recursos Completos
        </p>

        {/* Product Mockup */}
        <div className="w-full max-w-xs sm:max-w-lg md:max-w-xl mb-0 cursor-pointer transform hover:scale-105 transition-transform duration-300" onClick={scrollToOffer} data-id="element-88">
          <img src="https://cdn.magicpatterns.com/uploads/tCD7ZagW93aRHqZkHBHRsM/MOCKUPS_FILOSOFIA.png" alt="Kit Completo Filosofía Lista Mockup" className="w-full h-auto drop-shadow-2xl animate-float" data-id="element-89" />
        </div>

        {/* Subtitle */}
        <p className="text-sm sm:text-lg md:text-xl text-gray-200 max-w-2xl mx-auto mb-2 font-medium leading-snug drop-shadow-md" data-id="element-90">
          Material integral y listo para usar para trabajar los ejes centrales
          de la Filosofía en secundaria.
        </p>

        {/* Buttons */}
        <div className="flex flex-col sm:flex-row gap-1.5 w-full sm:w-auto" data-id="element-91">
          <button onClick={scrollToOffer} className="flex items-center justify-center bg-[#dc2626] hover:bg-red-700 text-white text-sm sm:text-lg font-bold py-2.5 px-5 sm:px-8 rounded-lg shadow-[0_4px_14px_0_rgba(220,38,38,0.39)] transition-all transform hover:-translate-y-1 w-full sm:w-auto border-b-4 border-red-900 active:border-b-0 active:translate-y-0" data-id="element-92">
            Adquirir Ahora <ArrowRight className="ml-2 h-5 w-5" data-id="element-93" />
          </button>

          <button onClick={scrollToInfo} className="flex items-center justify-center bg-transparent hover:bg-white/10 text-white border-2 border-white/30 text-sm sm:text-lg font-semibold py-2.5 px-5 sm:px-8 rounded-lg transition-all w-full sm:w-auto backdrop-blur-sm" data-id="element-94">
            Más Información
          </button>
        </div>
      </div>
    </section>;
}